export const contentPaddingX = { paddingX: 4 };
export const contentPaddingY = { paddingY: 4 };
export const sectionBorder = { borderBottom: '1px solid', borderColor: 'gray.200' };
